var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2746_53)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.832 12.499C10.832 11.1183 11.9513 9.99902 13.332 9.99902H16.6654C18.0461 9.99902 19.1654 11.1183 19.1654 12.499V27.499C19.1654 28.8798 18.0461 29.999 16.6654 29.999H13.332C11.9513 29.999 10.832 28.8798 10.832 27.499V12.499ZM13.332 11.6657C12.8718 11.6657 12.4987 12.0388 12.4987 12.499V27.499C12.4987 27.9593 12.8718 28.3324 13.332 28.3324H16.6654C17.1256 28.3324 17.4987 27.9593 17.4987 27.499V12.499C17.4987 12.0388 17.1256 11.6657 16.6654 11.6657H13.332Z",
    fill: "#db9f7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 22.501C1 21.1202 2.11929 20.001 3.5 20.001H6.83333C8.21408 20.001 9.33333 21.1202 9.33333 22.501V27.501C9.33333 28.8817 8.21408 30.001 6.83333 30.001H3.5C2.11929 30.001 1 28.8817 1 27.501V22.501Z",
    fill: "#db9f7d"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.667 2.5C20.667 1.11929 21.7862 0 23.167 0H26.5003C27.8811 0 29.0003 1.11929 29.0003 2.5V27.5C29.0003 28.8808 27.8811 30 26.5003 30H23.167C21.7862 30 20.667 28.8808 20.667 27.5V2.5ZM23.167 1.66667C22.7067 1.66667 22.3337 2.03977 22.3337 2.5V27.5C22.3337 27.9603 22.7067 28.3333 23.167 28.3333H26.5003C26.9606 28.3333 27.3337 27.9603 27.3337 27.5V2.5C27.3337 2.03977 26.9606 1.66667 26.5003 1.66667H23.167Z",
    fill: "#db9f7d"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2746_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBad);
export default __webpack_public_path__ + "res/media/bad.b4cb7deb30ce558baf412a89f3d1baea.svg";
export { ForwardRef as ReactComponent };